import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { DATE_FORMAT } from "../../../../../server/types";
import getToken from "../../../getters/getToken";
import useRejectWithMessage from "../../../hooks/useRejectWithMessage";
import { getLogUpdatedPriceList } from "../../../requests";
import Context from "./Context";
import useExtractFilter from "./hooks/useExtractFilter";
import { ProviderFC, TContext } from "./types";

const Provider: ProviderFC = ({ children }) => {
  const stateLoadingStatus = useState<TContext["isLoading"]["value"]>(false);
  const stateItems = useState<TContext["items"]["value"]>([]);
  const stateExpanded = useState<TContext["expanded"]["value"]>([]);
  const stateShowLog = useState<TContext["showLog"]["value"]>(null);
  const stateLastPage = useState<TContext["isLastPage"]["value"]>(true);
  const statePerPage = useState<TContext["perPage"]["value"]>(10);
  const statePage = useState<TContext["page"]["value"]>(0);
  const stateLastIdsByPage = useState<TContext["lastIdByPage"]["value"]>([]);
  const filter = useExtractFilter();
  const [searcParams] = useSearchParams();
  const stateFilter = useState<TContext["filter"]["value"]>(filter);
  const token = getToken();
  const handlerReject = useRejectWithMessage("Ошибка загрузки записей");
  const loading: TContext["loader"] = (params) => {
    stateLoadingStatus[1](true);
    return getLogUpdatedPriceList(
      token,
      {
        ...filter,
        fromDate: (filter.fromDate ?? moment()).format(DATE_FORMAT),
        toDate: (filter.toDate ?? moment()).format(DATE_FORMAT),
      },
      { perPage: statePerPage[0], ...(params ?? {}) }
    )
      .then(({ list, isLastPage }) => {
        stateItems[1](list);
        stateExpanded[1]([]);
        stateLastPage[1](isLastPage);
        stateLastIdsByPage[1]({
          ...stateLastIdsByPage[0],
          [params?.page ?? 0]: Math.min(...list.map(({ id }) => id)),
        });
        return list;
      })
      .catch(handlerReject)
      .then((result) => {
        stateLoadingStatus[1](false);
        return result ?? false;
      });
  };
  useEffect(() => {
    loading();
  }, [searcParams.toString(), statePerPage[0]]);
  return (
    <Context.Provider
      value={{
        isLoading: {
          value: stateLoadingStatus[0],
          update: stateLoadingStatus[1],
        },
        items: { value: stateItems[0], update: stateItems[1] },
        expanded: { value: stateExpanded[0], update: stateExpanded[1] },
        showLog: { value: stateShowLog[0], update: stateShowLog[1] },
        filter: { value: stateFilter[0], update: stateFilter[1] },
        isLastPage: { value: stateLastPage[0], update: stateLastPage[1] },
        perPage: { value: statePerPage[0], update: statePerPage[1] },
        page: { value: statePage[0], update: statePage[1] },
        lastIdByPage: {
          value: stateLastIdsByPage[0],
          update: stateLastIdsByPage[1],
        },
        loader: loading,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default Provider;
